import React from "react";
import { UserDetail } from "core/interfaces";

export const UserContext = React.createContext<{
  user: UserDetail;
  getUserList: () => void;
}>(Object.assign({}));
